import { render } from "./Proyects.vue?vue&type=template&id=2c58662f&scoped=true"
import script from "./Proyects.vue?vue&type=script&lang=js"
export * from "./Proyects.vue?vue&type=script&lang=js"

import "./Proyects.vue?vue&type=style&index=0&id=2c58662f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c58662f"]])

export default __exports__